import React from "react";
import Form from "react-bootstrap/Form";
import card3 from "../../Assets/Images/AIImg.png";

function ConsultationForm({ register, errors, onSubmit, consulatation, isLoading }) {
  return (
    <div className="chat_inn_box">
      <div className="img-chat-date d-flex">
        <div className="profile-chat-img">
          <img src={card3} alt="AI Avatar" />
        </div>

        <div className="chat_box_outer">
          <div className="chat-box">
            <p className="chat_text second_user_txt">
              Please provide your details to proceed with the consultation.
            </p>
            <span className="cs_chat_time second">
              {new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true })}
            </span>
          </div>

          <form onSubmit={onSubmit}>
            <div className="inner_chat_form_box">
              <h4 className="comnchat_heading">
                1. Please provide your age and biological sex
              </h4>
              <Form.Group className="comn-class-inputs">
                <Form.Label>Age</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Enter Your Age e.g 18"
                  disabled={consulatation}
                  min={1}
                  max={125}
                  {...register("age", {
                    required: "Please enter age.",
                    min: { value: 1, message: "Age must be at least 1." },
                    max: { value: 125, message: "Age cannot exceed 125." }
                  })}
                  isInvalid={!!errors.age}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.age?.message}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="comn-class-inputs mt-3">
                <Form.Label>Select Your Gender</Form.Label>
                <div className="cst_radio_box_outer">
                  {["male", "female", "others"].map((gender) => (
                    <Form.Check
                      key={gender}
                      inline
                      label={gender.charAt(0).toUpperCase() + gender.slice(1)}
                      name="gender"
                      type="radio"
                      id={`gender-${gender}`}
                      className="custom-radio"
                      value={gender.toUpperCase()}
                      disabled={consulatation}
                      {...register("gender", { required: "Please select a gender" })}
                    />
                  ))}
                </div>
                {errors.gender && (
                  <span className="text-danger small">{errors.gender.message}</span>
                )}
              </Form.Group>

              <h4 className="comnchat_heading mt-4">2. What would you like to discuss?</h4>
              <div className="d-flex chat_box_checkbox_outer">
                <div className="past_history_checkbox_col">
                  <Form.Group className="custom-checkbox past_history_checkbox">
                    <Form.Check
                      type="checkbox"
                      label="A Condition"
                      id="checkbox1"
                      disabled={consulatation}
                      {...register("discussion.condition1")}
                    />
                  </Form.Group>
                </div>
                <div className="past_history_checkbox_col">
                  <Form.Group className="custom-checkbox past_history_checkbox">
                    <Form.Check
                      type="checkbox"
                      label="Any Symptoms"
                      id="checkbox2"
                      disabled={consulatation}
                      {...register("discussion.condition2")}
                    />
                  </Form.Group>
                </div>
                <div className="past_history_checkbox_col">
                  <Form.Group className="custom-checkbox past_history_checkbox">
                    <Form.Check
                      type="checkbox"
                      label="Health Questions"
                      id="checkbox3"
                      disabled={consulatation}
                      {...register("discussion.condition3")}
                    />
                  </Form.Group>
                </div>
              </div>
            </div>

            {!consulatation && (
              <button type="submit" className="main-btn chat_inner_btn w-100 mt-3" disabled={isLoading}>
                {isLoading ? "Starting..." : "Start consultation"}
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default ConsultationForm;